import { render, staticRenderFns } from "./RegretSuccessModal.vue?vue&type=template&id=6a8a00a5&scoped=true"
import script from "./RegretSuccessModal.vue?vue&type=script&lang=js"
export * from "./RegretSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./RegretSuccessModal.vue?vue&type=style&index=0&id=6a8a00a5&prod&lang=scss"
import style1 from "./RegretSuccessModal.vue?vue&type=style&index=1&id=6a8a00a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8a00a5",
  null
  
)

export default component.exports